import { render, staticRenderFns } from "./addExpenseSection.vue?vue&type=template&id=0f3f07f6&"
import script from "./addExpenseSection.vue?vue&type=script&lang=js&"
export * from "./addExpenseSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports